<template>
    <li class="tweet">
        <a href="https://twitter.com/share" class="twitter-share-button" :data-url="url" data-via="tiff_site" :data-lang="lang" :data-text="text" data-counturl="#" data-related="tiff_site" style="display:none;">ツイート</a>
    </li>
</template>

<script>

export default {
  name: 'tweet',
  props: ['url','text','lang'],
  updated() {
      if (typeof twttr === 'undefined') {
        var twitterjs = document.createElement("script");
        twitterjs.async = true;
        twitterjs.src = '//platform.twitter.com/widgets.js';
        document.getElementsByTagName('body')[0].appendChild(twitterjs);
      }
      else {
        twttr.widgets.load();
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tweet.vue